import React, { useState, useEffect } from "react";
import {
  Text,
  View,
  TouchableOpacity,
  Image,
  Platform,
  Pressable,
} from "react-native";
import StyleSheet from "react-native-media-query";
import { clearSessionAndLogout } from "@lib/utilities/AuthHelper";
import { useAuth0 } from "@auth0/auth0-react";
import CommonStyle from "../../assets/styles/common-style";
import Color from "../../assets/color/Color";
import { ScreenNameList } from "@lib/utilities/Constants";
import { LOGO, VERIFIED_ICON } from "../../resources/IMAGES";
import { theme } from "../../theme/theme";
import { description, labelText, messages } from "../../resources/strings";
import { useAppSelector } from "@lib";

const RegisterSuccessView = (props: any) => {
  const [heading, setHeading] = useState(``);
  const { isConnected } = useAppSelector((state) => state.userReducer);
  

  useEffect(() => {
    props.screenName == ScreenNameList.register
      ? setHeading(messages.success.accountCreated)
      : setHeading(labelText.reset.resetPassword);
  }, []);

  const { logout } = useAuth0();

  const alreadyHaveAccountLogin = async () => {
    if (isConnected) {
      Platform.OS == "web" ? handleLogout(logout) : handleLogout(null);
    } else {
      props.onNoInternet();
    }
  };

  const handleLogout = (_logout: any) => {
    clearSessionAndLogout(props.navigation, _logout);
  };

  return (
    <View
      style={{
        flex: 1,
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <View style={[styles.loginSuccess]} dataSet={{ media: ids.loginSuccess }}>
        <View style={[styles.logoBlock]} dataSet={{ media: ids.logoBlock }}>
          {Platform.OS == "web" ? (
            <Image
              style={styles.Logo}
              dataSet={{ media: ids.Logo }}
              source={LOGO}
              resizeMode={"contain"}
            />
          ) : (
            <Image
              style={styles.Logo}
              dataSet={{ media: ids.Logo }}
              source={LOGO}
            />
          )}
        </View>
        <View
          style={[styles.heading, CommonStyle.styles.inMiddle]}
          dataSet={{ media: ids.heading }}
        >
          <Text
            style={[styles.headingText]}
            dataSet={{ media: ids.headingText }}
          >
            {heading}
          </Text>
        </View>
        <View
          style={[styles.verifiedBlock]}
          dataSet={{ media: ids.verifiedBlock }}
        >
          <Image
            style={styles.verifiedIcon}
            dataSet={{ media: ids.verifiedIcon }}
            source={VERIFIED_ICON}
          />
        </View>
        {props.screenName == ScreenNameList.resetPassword && (
          <View
            style={[CommonStyle.styles.inMiddle]}
            dataSet={{ media: CommonStyle.ids.inMiddle }}
          >
            <Text
              style={[styles.whiteText, styles.textCenter]}
              dataSet={{ media: ids.whiteText }}
            >
              {messages.success.resetPasswordSuccess}
            </Text>
          </View>
        )}
        {props.screenName == ScreenNameList.register && props.verifyEmail && (
          <View
            style={[CommonStyle.styles.inMiddle]}
            dataSet={{ media: CommonStyle.ids.inMiddle }}
          >
            <Text
              style={[styles.whiteText, styles.textCenter]}
              dataSet={{ media: ids.whiteText }}
            >
              {description.reset.description2}
              <Text style={[styles.textBold]} dataSet={{ media: ids.textBold }}>
                {" "}
                {props.email}
              </Text>
            </Text>
            <Text style={[styles.whiteText]} dataSet={{ media: ids.whiteText }}>
              {description.reset.description3}
            </Text>
          </View>
        )}

        <Pressable
          style={[styles.submitButton]}
          dataSet={{ media: ids.submitButton }}
          onPress={() => {
            alreadyHaveAccountLogin();
          }}
        >
          <Text style={[styles.btnText]} dataSet={{ media: ids.btnText }}>
            {labelText.button.login}
          </Text>
        </Pressable>
      </View>
    </View>
  );
};

// Define your styles
const { ids, styles } = StyleSheet.create({
  loginSuccess: {
    flex: 1,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    maxWidth: 600,
    ...Platform.select({
      ios: {
        "@media (min-width: 200px)": {
          paddingLeft: 16,
          paddingRight: 16,
        },
        "@media (min-width: 600px)": {
          paddingLeft: 0,
          paddingRight: 0,
        },
      },
      android: {
        "@media (min-width: 200px)": {
          paddingLeft: 16,
          paddingRight: 16,
        },
        "@media (min-width: 600px)": {
          paddingLeft: 0,
          paddingRight: 0,
        },
      },
      web: {
        paddingLeft: 16,
        paddingRight: 16,
        width: "100%",
      },
    }),
  },
  logoBlock: {
    marginBottom: 24,
  },
  Logo: {
    width: 300,
    height: 100,
    display: "flex",
    resizeMode: "contain",
    "@media (min-width: 700px)": {
      width: 400,
      height: 120,
    },
  },
  verifiedIcon: {
    "@media (min-width: 200px)": {
      width: 142,
      height: 142,
    },
    "@media (min-width: 700px)": {
      width: 182,
      height: 182,
    },
  },
  heading: {
    width: "100%",
    ...Platform.select({
      ios: {
        marginBottom: 12,
      },
      android: {
        marginBottom: 8,
      },
      web: {
        marginBottom: 24,
        marginTop: 16,
      },
    }),
  },
  headingText: {
    ...Platform.select({
      ios: {
        "@media (min-width: 200px)": {
          fontFamily: "Roboto Slab",
          fontSize: 25,
        },
        "@media (min-width: 700px)": {
          fontFamily: "Roboto Slab",
          fontSize: 30,
        },
      },
      android: {
        "@media (min-width: 200px)": {
          fontFamily: "Roboto Slab",
          fontSize: 25,
        },
        "@media (min-width: 700px)": {
          fontFamily: "Roboto Slab",
          fontSize: 30,
        },
      },
      web: {
        lineHeight: 1,
        "@media (min-width: 200px)": {
          fontFamily: "Roboto Slab",
          fontSize: 22,
        },
        "@media (min-width: 700px)": {
          fontFamily: "Roboto Slab",
          fontSize: 25,
        },
        "@media (min-width: 1150px)": {
          fontFamily: "Roboto Slab",
          fontSize: 25,
        },
        "@media (min-width: 1681px)": {
          fontFamily: "Roboto Slab",
          fontSize: 32,
        },
      },
    }),
    fontWeight: "bold",
    fontStyle: "normal",
    letterSpacing: 0,
    textAlign: "left",
    color: theme.colors.white,
  },
  verifiedBlock: {
    marginTop: 16,
    marginBottom: 24,
  },
  whiteText: {
    color: theme.colors.white,
  },
  textCenter: {
    textAlign: "center",
  },
  submitButton: {
    minWidth: "100%",
    backgroundColor: theme.colors.button.primary,
    padding: 12,
    textAlign: "center",
    display: "flex",
    alignItems: "center",
    borderRadius: 10,
    marginTop: 16,
    marginBottom: 24,
    fontWeight: "600",
  },
  btnText: {
    fontFamily: theme.fontFamily.robotoBold,
    fontWeight: "600",
    color: theme.colors.white,
    fontSize: 18,
  },
  textBold: {
    fontWeight: "bold",
  },
});

export default RegisterSuccessView;
